import {DispositionsByUnfinishedRequestTemplateData} from "./DispositionsByUnfinishedRequestTemplateData";
import {DispositionsByUnfinishedRequestImportTemplate} from "./DispositionsByUnfinishedRequestImportTemplate";

export const getDispositionsByUnfinishedRequestTemplate = (
    date: string,
    dispositionNumber: string,
    productName: string | string[],
    amount: string | string[],
    inputLocation: string,
    outputLocation: string,
    vehicle: string,
    driverName: string,
    isMercantile: boolean,
    ) => {
    return DispositionsByUnfinishedRequestImportTemplate(
        prepareData(
            date,
            dispositionNumber,
            productName,
            amount,
            inputLocation,
            outputLocation,
            vehicle,
            driverName,
            isMercantile
        )
    );
};

const prepareData = (
    date: string,
    dispositionNumber: string,
    productName: string | string[],
    amount: string | string[],
    inputLocation: string,
    outputLocation: string,
    vehicle: string,
    driverName: string,
    isMercantile: boolean
    ) => {
    const templateData: DispositionsByUnfinishedRequestTemplateData = {
        date: date,
        dispositionNumber: dispositionNumber,
        productName: productName,
        amount: amount,
        inputLocation: inputLocation,
        outputLocation: outputLocation,
        vehicle: vehicle,
        driverName: driverName,
        isMercantile: isMercantile,
        repromaterialProductName: productName as string[],
        repromaterialProductAmount: amount as string[],
    };
    return templateData;
};